// extracted by mini-css-extract-plugin
export default {"locator":"locator_locator__0z+em"};